const translations = {
      en: {
        role: "Software Engineer",
        description: "Code-driven, Solution-focused.",
        about: "About",
        skills: "Skills",
        experience: "Experience",
        projects: "Projects"
      },
      id: {
        role: "Software Engineer",
        description: "Berfokus pada solusi berbasis kode.",
        about: "Tentang Saya",
        skills: "Kemampuan",
        experience: "Pengalaman",
        projects: "Proyek"
      },
    };
  
  export default translations;